import React, { PureComponent } from 'react';

class ShockwaveAnimation extends PureComponent {
    render() {
        return (
            <div style={styles.container}>
                <style>{keyframes}</style>
                <div style={styles.coreFlash} />
                <div style={styles.ring1} />
                <div style={styles.ring2} />
                <div style={styles.ring3} />
                <div style={styles.coreOrb} />
            </div>
        );
    }
}

const keyframes = `
@keyframes sw-flash {
    0% { transform: scale(0); opacity: 0; }
    10% { transform: scale(0.5); opacity: 1; }
    40% { opacity: 0.6; }
    100% { transform: scale(8); opacity: 0; }
}
@keyframes sw-ring {
    0% { transform: scale(0); opacity: 0.8; }
    100% { transform: scale(6); opacity: 0; }
}
@keyframes sw-orb {
    0% { transform: scale(0); opacity: 0; }
    15% { transform: scale(1.3); opacity: 1; }
    30% { transform: scale(1); opacity: 1; }
    100% { transform: scale(0); opacity: 0; }
}
`;

const ringBase = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: 80,
    height: 80,
    marginTop: -40,
    marginLeft: -40,
    borderRadius: '50%',
    border: '3px solid',
};

const styles = {
    container: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 9999,
        overflow: 'hidden',
    },
    coreFlash: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: 60,
        height: 60,
        marginTop: -30,
        marginLeft: -30,
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255,255,255,0.95), rgba(100,180,255,0.6), transparent)',
        animation: 'sw-flash 1.2s ease-out forwards',
    },
    ring1: {
        ...ringBase,
        borderColor: 'rgba(100, 180, 255, 0.8)',
        boxShadow: '0 0 15px rgba(100, 180, 255, 0.4), inset 0 0 15px rgba(100, 180, 255, 0.1)',
        animation: 'sw-ring 1.4s ease-out forwards',
    },
    ring2: {
        ...ringBase,
        borderColor: 'rgba(140, 120, 255, 0.6)',
        boxShadow: '0 0 12px rgba(140, 120, 255, 0.3)',
        animation: 'sw-ring 1.4s ease-out 0.15s forwards',
    },
    ring3: {
        ...ringBase,
        borderColor: 'rgba(200, 160, 255, 0.4)',
        boxShadow: '0 0 10px rgba(200, 160, 255, 0.2)',
        animation: 'sw-ring 1.4s ease-out 0.3s forwards',
    },
    coreOrb: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: 24,
        height: 24,
        marginTop: -12,
        marginLeft: -12,
        borderRadius: '50%',
        background: 'radial-gradient(circle, #ffffff, #80b0ff, #5060d0)',
        boxShadow: '0 0 20px rgba(100, 150, 255, 0.6)',
        animation: 'sw-orb 1.6s ease-in-out forwards',
    },
};

export default ShockwaveAnimation;
